/**
 * Flips a "+" upsell button (in sections/variant-added.liquid, the "added to cart" popup) to a green
 * checkmark the instant it's submitted, as immediate confirmation during the round trip to the server.
 *
 * Delegated at `document` on purpose, not attached to the buttons themselves: this popup's whole section
 * gets replaced with a fresh server render every time any item is added to it (see quick-buy-drawer.js's
 * _onVariantAdded), including right after this very button's own submit — a listener bound to the button
 * itself would just get thrown away with it. A delegated listener on `document` survives every swap.
 */
document.addEventListener("submit", function (event) {
  var form = event.target;
  if (!form.classList || !form.classList.contains("variant-added-upsell__form")) return;

  var button = form.querySelector(".variant-added-upsell__add");
  if (button) {
    button.classList.add("variant-added-upsell__add--done");
  }
});
